import clsx from 'clsx';
import React, { FunctionComponent, memo } from 'react';
import { useSelector } from 'react-redux';

import Button from '../../components/button';
import Modal from '../../components/common/modal';
import Typography from '../../components/typography';
import { RootState } from '../../redux/reducers';

interface Props {
  className?: string;
}

const GlobalModal: FunctionComponent<Props> = ({ className = '' }: Props) => {
  const { isOpen, content } = useSelector((state: RootState) => state.modal);

  return (
    <Modal
      isShifted
      className={clsx(className, 'w-100')}
      content={
        <div className="flex w-full flex-col text-gray-100">
          <div className="flex items-center justify-between">
            <Typography variant="h4">{content?.title as any}</Typography>
            {content?.displayClose && (
              <button
                className="flex items-center justify-center rounded p-1 transition hover:bg-gray-10"
                type="button"
                onClick={content?.onClose}
              >
                <span
                  key="close"
                  className="material-icons-outlined text-gray-100"
                >
                  close
                </span>
              </button>
            )}
          </div>
          <Typography className="mt-3 text-gray-70">
            {content?.description as any}
          </Typography>
          <div className="mt-6 flex justify-end space-x-3">
            {content?.buttons?.map((button) => (
              <Button
                key={button.label}
                className={clsx(button.shouldStretch && 'flex-1 flex-grow')}
                tabIndex={0}
                variant={button.type as any}
                onClick={button.onClick}
              >
                {button.label}
              </Button>
            ))}
          </div>
          {content?.children}
        </div>
      }
      handleOnClose={content?.canClickOutside ? content?.onClose : () => {}}
      isOpen={isOpen}
    />
  );
};

export default memo(GlobalModal);
